import React from 'react';
import Panel from '../components/Panel';
import InputSelect from '../components/InputSelect';
import store, {actions} from '../store';
import auth from '../lib/auth';
import _ from 'lodash';
import Input from '../components/Input';
import InputTextArea from '../components/InputTextArea';
import {Alert} from 'reactstrap';

export default class ManageFaqs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching: false,
      submitting: false,
      deleted: false,
      saved: false,
      data: {},
    };

    this.handleTopicSelect = this.handleTopicSelect.bind(this);
    this.addQuestionField = this.addQuestionField.bind(this);
    this.save = this.save.bind(this);
    this.remove = this.remove.bind(this);
    this.handleSortOrderChange = this.handleSortOrderChange.bind(this);
  }

  async componentDidMount() {
    let [user, faqs] = await Promise.all([
      auth.user(),
      store.dispatch(actions.faqs.fetchAll()),
    ]);

    this.user = user;

    this.setState({
      initializing: false,
      user,
      faqs,
    });
  }

  save() {
    this.setState({
      submitting: true,
    });

    let data = Object.assign({}, this.state.data);
    data.faqQA = (data.faqQA||[]).filter(item => !_.isEmpty(item));
    data.faqOrder = data.faqOrder ? data.faqOrder : 0;

    store.dispatch(actions.faqs.createOrUpdate(data)).
        then((result)=>{
          if (this.state.data.faqId) {
            this.setState({
              saved: true,
              submitting: false,
              faqs: _.map(this.state.faqs, (faq) => {
                if (this.state.data.faqId ===
                    faq.faqId) return this.state.data;
                return faq;
              }),
              data
            });
          } else {
            this.setState({
              data: result,
              submitting: false,
              saved: true,
              faqs: this.state.faqs.push(result),
            });
          }

          setTimeout(() => {
            this.setState({
              saved: false,
            });
          }, 3000);
        }).
        catch((err) => {
          alert(err.message);
          this.setState({
            submitting: false,
          });
        });

  }

  remove() {
    if (!window.confirm(
        `Are you sure want to remove '${this.state.data.faqName}'`)) {
      return;
    }
    this.setState({
      deleting: true,
    });

    store.dispatch(actions.faqs.remove(this.state.data.faqId)).
        then(result => {
          this.setState({
            deleted: true,
            deleting: false,
            faqs: _.filter(this.state.faqs, (faq) => {
              return (this.state.data.faqId !==
                  faq.faqId);
            }),
            data: {},
          });
          setTimeout(() => {
            this.setState({
              deleted: false,
            });
          }, 3000);
        }).
        catch(err => {
          alert(err.message);
          this.setState({
            deleting: false,
          });
        });

  }

  handleTopicSelect(data) {
    if (!data) {
      this.setState({
        data: {},
      });
    } else if (_.isObject(data)) {
      this.setState({
        data: data,
      });
    } else if (_.isString(data)) {
      this.setState({
        data: {
          faqName: data,
        },
      });
    }
  }

  addQuestionField() {
    this.setState({
      data: Object.assign({}, this.state.data, {
        faqQA: (this.state.data.faqQA || []).concat({}),
      }),
    });
  }

  handleQAFieldChange(index, name, value) {
    let qaList = (this.state.data.faqQA || []);
    qaList[index][name] = value;
    this.setState({
      data: Object.assign({}, this.state.data, {
        faqQA: qaList,
      }),
    });
  }
  handleSortOrderChange(value){
    this.setState({
      data: Object.assign({}, this.state.data, {
        faqOrder: value,
      }),
    })
  }

  renderControls() {
    return (
        <button
            className="btn btn-default"
            disabled={!this.state.data.faqName}
            onClick={this.addQuestionField}

        >
          <i className="fa fa-plus"></i> &nbsp;
          Add Question
        </button>
    );
  }

  renderQA(qa, index, last = false) {
    let stack = [
      <div style={{paddingTop: '20px'}} key={index + '_qa'}>
        <Input labelIndented
               label="Question"
               value={qa.q || ''}
               onChange={this.handleQAFieldChange.bind(this, index, 'q')}
        />
        <InputTextArea labelIndented
                       label="Answer"
                       value={qa.a || ''}
                       onChange={this.handleQAFieldChange.bind(this, index,
                           'a')}
                       styles={{
                         minHeight: '100px',
                       }}
        />
      </div>,
    ];

    if (!last) {
      stack.push((<div className="dropdown-divider"  key={index + '_divider'}></div>));
    }

    return stack;
  }


  render() {
    return (
        <Panel
            title="FAQs"
            controls={this.renderControls()}
        >
          <Alert color="success" isOpen={this.state.saved}>
            FAQ Saved
          </Alert>
          <Alert color="info" isOpen={this.state.deleted}>
            FAQ Deleted
          </Alert>
          <InputSelect
              label="Topic"
              placeholder={this.state.fetching ?
                  'Fetching...' :
                  'New Topic or Select Existing'}
              options={_.map(this.state.faqs, (faq) => {
                return {label: faq.faqName, value: faq};
              })}
              onChange={this.handleTopicSelect}
              creatable
              simpleValue
              value={this.state.data.faqName ?
                  {
                    label: this.state.data.faqName,
                    value: this.state.data.faqName,
                  } :
                  null}
              promptTextCreator={(label) => `Create new topic '${label}'`}
          />
          <Input type="number"
                 label="Sort Order"
                 onChange={this.handleSortOrderChange}
                 value={this.state.data.faqOrder ? this.state.data.faqOrder : 0 }
          />
          {
            this.state.data.faqQA ? (
                <div>
                  <h4>Questions</h4>
                  {
                    _.map((this.state.data.faqQA || []),
                        (qa, index, collection) => {
                          return this.renderQA(qa, index, collection.length ===
                              index + 1);
                        })
                  }
                </div>
            ) : null
          }
          <div className="container-fluid clearfix" style={{
            borderTop: '1px solid #ccc',
            padding: '30px 60px 10px',
            margin: '0 -20px',
            width: 'auto',
          }}>
            <button className="btn btn-outline-danger pull-left px-5"
                    disabled={this.state.submitting ||
                    !this.state.data.faqId || this.state.deleting}
                    onClick={this.remove}
            >
              {this.state.deleting ? 'Deleting...' : 'Delete'}
            </button>
            <button className="btn btn-purple pull-right px-5"
                    disabled={this.state.submitting ||
                    !this.state.data.faqName || this.state.deleting}
                    onClick={this.save}
            >
              {this.state.submitting ?
                  'Saving...' :
                  (this.state.data.faqId ? 'Save' : 'Create')}
            </button>
          </div>
        </Panel>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/ManageFaqs.js